import { Deserializable } from '../../deserializable';

export class ApplicantDto implements Deserializable {
  public ApplicantIdentifier: string;
  public ApplicantName: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
